const PersonConsent = {
  TypeEmail: "Email",
  TypePhone: "Telephone",
  TypePost: "Post",
  TypeSms: "Sms"
};

export default PersonConsent;
